'use server'

import { createClient } from '@repo/db/server'
import { requirePermission } from '@/lib/permissions'

export async function getWalletBalance(): Promise<{ balance: number; currency: string }> {
  const perms = await requirePermission('dashboard', 'read')
  const supabase = await createClient()

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { data: wallet } = await (supabase as any)
    .from('wallets')
    .select('balance, currency')
    .eq('tenant_id', perms.tenantId)
    .single()

  return {
    balance: wallet ? Number(wallet.balance) : 0,
    currency: wallet?.currency ?? 'TRY',
  }
}
